module.exports = __webpack_public_path__ + "static/media/quotes-step-icon-fc.060549cb.svg";